module.exports = __webpack_public_path__ + "static/media/logo2.0a3fc413.png";